import { observable, computed, action, decorate } from "mobx";
import * as mobx from 'mobx';
import { runInAction } from "mobx";

import * as login from '../communicator/login';

function isEnabledFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'on';
}

class StoreAuth {
    user = {
        user_id: 0,
        is_loggedin: false,
        is_admin: false,
        is_reseller: false,
        is_partner: false,
        access_level: 0,
        no_shipping_costs: false
    }

    constructor() {

    }

    async checkLogin(formControls) {
        let result;
        const data = {
            email: formControls.email.value,
            pw: formControls.password.value
        };
        
        try {
            const returnData = await login.checkLogin(data);
            runInAction(() => {
                result = returnData.data[0];
                const userId = Number(result && result.id);
                const hasUserToken = Boolean(result && (result.token || result.user_token || result.guid));
                const hasError = !result || ('error' in result) || !hasUserToken;
                if (!hasError && Number.isSafeInteger(userId) && userId > 0) {
                    this.user.user_id = userId;
                    this.user.access_level = result.access_level;
                    this.user.is_loggedin = true;
                    this.user.is_admin = (result.admin === "on" || result.admin === "1")
                        ?   true
                        :   false
                    this.user.is_partner = (result.is_partner === "on" || result.is_partner === "1")
                        ?   true
                        :   false
                    this.user.is_reseller = (result.is_reseller === "on" || result.is_reseller === "1")
                        ?   true
                        :   false
                    this.user.no_shipping_costs = isEnabledFlag(result.no_shipping_costs);
                } else {
                    result = ('error' in (result || {}))
                        ? result
                        : { error: hasUserToken ? 'Invalid login data' : 'Login response has no user token' };
                    this.setLogoutState();
                }
                return result;
            })
        } catch (error) {
            runInAction(() => {
                this.user.is_loggedin = false;
            })
        }

        return result;
    }

    refreshAuth(data) {
        if ('is_partner' in data) {
            this.user.is_partner = ((data.is_partner === "on" || data.is_partner === "1") && data.partner_code !== '')
                ?   true
                :   false
        }
    }

    setAuth(data) {
        const rawUserId = data && (data.user_id !== undefined ? data.user_id : data.id);
        const userId = Number(rawUserId);
        const hasValidUserId = Number.isSafeInteger(userId) && userId > 0;

        // Een sessie is alleen ingelogd wanneer er een echte account-id is.
        // De oude check vergeleek de letterlijke tekst 'user_id' en was dus
        // altijd waar, ook voor 0/null/undefined uit localStorage.
        this.user.user_id = hasValidUserId ? userId : 0;
        this.user.access_level = hasValidUserId ? (data.access_level || 0) : 0;
        this.user.is_loggedin = hasValidUserId;

        if (!hasValidUserId) {
            this.setLogoutState();
            return;
        }
        if ('is_admin' in data) {
            this.user.is_admin = (data.is_admin === "on" || data.is_admin === "1" || data.is_admin === true)
                ?   true
                :   false
        }
        if ('admin' in data) {
            this.user.is_admin = (data.admin === "on" || data.admin === "1")
                ?   true
                :   false
        }
        this.user.is_partner = data.is_partner;
        this.user.is_reseller = data.is_reseller;
        // Oude APP_USER-data bevat deze vlag niet altijd. Zet hem dan bewust
        // uit, zodat een eerdere klantvrijstelling niet blijft hangen.
        this.user.no_shipping_costs = isEnabledFlag(data.no_shipping_costs);
    }

    setLoginState(login) {
        const userId = Number(this.user.user_id);
        const canLogIn = Number.isSafeInteger(userId) && userId > 0;
        this.user.is_loggedin = Boolean(login) && canLogIn;

        if (!this.user.is_loggedin) {
            this.setLogoutState();
        }
    }

    setLogoutState() {
        this.user.user_id = 0;
        this.user.access_level = 0;
        this.user.is_loggedin = false;
        this.user.is_admin = false;
        this.user.is_partner = false;
        this.user.is_reseller = false;
        this.user.partner_status = '';
        this.user.no_shipping_costs = false;
    }
}

decorate(StoreAuth, {
    user: observable,
    checkLogin: action,
    refreshAuth: action,
    setAuth: action,
    setLoginState: action,
    setLogoutState: action
})

export default StoreAuth;
